//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  au: "Австралия",
  at: "Австрия",
  az: "Азербайджан",
  al: "Албания",
  dz: "Алжир",
  as: "Американска Самоа",
  vi: "Американски Вирджински острови",
  ao: "Ангола",
  ai: "Ангуила",
  ad: "Андора",
  aq: "Антарктика",
  ag: "Антигуа и Барбуда",
  ar: "Аржентина",
  am: "Армения",
  aw: "Аруба",
  af: "Афганистан",
  bd: "Бангладеш",
  bb: "Барбадос",
  bs: "Бахамски острови",
  bh: "Бахрейн",
  by: "Беларус",
  be: "Белгия",
  bz: "Белиз",
  bj: "Бенин",
  bm: "Бермудски острови",
  bo: "Боливия",
  ba: "Босна и Херцеговина",
  bw: "Ботсвана",
  br: "Бразилия",
  io: "Британска територия в Индийския океан",
  vg: "Британски Вирджински острови",
  bn: "Бруней Даруссалам",
  bf: "Буркина Фасо",
  bi: "Бурунди",
  bt: "Бутан",
  bg: "България",
  vu: "Вануату",
  va: "Ватикан",
  ve: "Венецуела",
  vn: "Виетнам",
  ga: "Габон",
  gm: "Гамбия",
  gh: "Гана",
  gy: "Гаяна",
  gp: "Гваделупа",
  gt: "Гватемала",
  gn: "Гвинея",
  gw: "Гвинея-Бисау",
  de: "Германия",
  gi: "Гибралтар",
  gd: "Гренада",
  gl: "Гренландия",
  ge: "Грузия",
  gu: "Гуам",
  gg: "Гърнзи",
  gr: "Гърция",
  dk: "Дания",
  dj: "Джибути",
  je: "Джърси",
  dm: "Доминика",
  do: "Доминиканска република",
  eg: "Египет",
  ec: "Еквадор",
  gq: "Екваториална Гвинея",
  er: "Еритрея",
  sz: "Есватини",
  ee: "Естония",
  et: "Етиопия",
  zm: "Замбия",
  eh: "Западна Сахара",
  zw: "Зимбабве",
  il: "Израел",
  tl: "Източен Тимор",
  in: "Индия",
  id: "Индонезия",
  iq: "Ирак",
  ir: "Иран",
  ie: "Ирландия",
  is: "Исландия",
  es: "Испания",
  it: "Италия",
  ye: "Йемен",
  jo: "Йордания",
  cv: "Кабо Верде",
  kz: "Казахстан",
  ky: "Кайманови острови",
  kh: "Камбоджа",
  cm: "Камерун",
  ca: "Канада",
  bq: "Карибска Нидерландия",
  qa: "Катар",
  ke: "Кения",
  cy: "Кипър",
  kg: "Киргизстан",
  ki: "Кирибати",
  cn: "Китай",
  cc: "Кокосови острови (острови Кийлинг)",
  co: "Колумбия",
  km: "Коморски острови",
  cg: "Конго (Бразавил)",
  cd: "Конго (Киншаса)",
  cr: "Коста Рика",
  ci: "Кот д’Ивоар",
  cu: "Куба",
  kw: "Кувейт",
  cw: "Кюрасао",
  la: "Лаос",
  lv: "Латвия",
  ls: "Лесото",
  lr: "Либерия",
  ly: "Либия",
  lb: "Ливан",
  lt: "Литва",
  li: "Лихтенщайн",
  lu: "Люксембург",
  mr: "Мавритания",
  mu: "Мавриций",
  mg: "Мадагаскар",
  yt: "Майот",
  mo: "Макао, САР на Китай",
  mw: "Малави",
  my: "Малайзия",
  mv: "Малдиви",
  ml: "Мали",
  mt: "Малта",
  ma: "Мароко",
  mq: "Мартиника",
  mh: "Маршалови острови",
  mx: "Мексико",
  mm: "Мианмар (Бирма)",
  fm: "Микронезия",
  mz: "Мозамбик",
  md: "Молдова",
  mc: "Монако",
  mn: "Монголия",
  ms: "Монтсерат",
  na: "Намибия",
  nr: "Науру",
  np: "Непал",
  ne: "Нигер",
  ng: "Нигерия",
  nl: "Нидерландия",
  ni: "Никарагуа",
  nu: "Ниуе",
  nz: "Нова Зеландия",
  nc: "Нова Каледония",
  no: "Норвегия",
  ae: "Обединени арабски емирства",
  gb: "Обединеното кралство",
  ax: "Оландски острови",
  om: "Оман",
  bv: "остров Буве",
  im: "остров Ман",
  nf: "остров Норфолк",
  cx: "остров Рождество",
  ck: "острови Кук",
  pn: "Острови Питкерн",
  tc: "острови Търкс и Кайкос",
  hm: "острови Хърд и Макдоналд",
  um: "Отдалечени острови на САЩ",
  pk: "Пакистан",
  pw: "Палау",
  ps: "Палестински територии",
  pa: "Панама",
  pg: "Папуа-Нова Гвинея",
  py: "Парагвай",
  pe: "Перу",
  pl: "Полша",
  pt: "Португалия",
  pr: "Пуерто Рико",
  re: "Реюнион",
  rw: "Руанда",
  ro: "Румъния",
  ru: "Русия",
  sv: "Салвадор",
  ws: "Самоа",
  sm: "Сан Марино",
  st: "Сао Томе и Принсипи",
  sa: "Саудитска Арабия",
  sj: "Свалбард и Ян Майен",
  sh: "Света Елена",
  kp: "Северна Корея",
  mk: "Северна Македония",
  mp: "Северни Мариански острови",
  vc: "Сейнт Винсънт и Гренадини",
  kn: "Сейнт Китс и Невис",
  lc: "Сейнт Лусия",
  sc: "Сейшели",
  bl: "Сен Бартелеми",
  mf: "Сен Мартен",
  pm: "Сен Пиер и Микелон",
  sn: "Сенегал",
  sl: "Сиера Леоне",
  sg: "Сингапур",
  sx: "Синт Мартен",
  sy: "Сирия",
  sk: "Словакия",
  si: "Словения",
  sb: "Соломонови острови",
  so: "Сомалия",
  sd: "Судан",
  sr: "Суринам",
  us: "Съединени щати",
  rs: "Сърбия",
  tj: "Таджикистан",
  tw: "Тайван",
  th: "Тайланд",
  tz: "Танзания",
  tg: "Того",
  tk: "Токелау",
  to: "Тонга",
  tt: "Тринидад и Тобаго",
  tv: "Тувалу",
  tn: "Тунис",
  tm: "Туркменистан",
  tr: "Турция",
  ug: "Уганда",
  uz: "Узбекистан",
  ua: "Украйна",
  hu: "Унгария",
  wf: "Уолис и Футуна",
  uy: "Уругвай",
  fo: "Фарьорски острови",
  fj: "Фиджи",
  ph: "Филипини",
  fi: "Финландия",
  fk: "Фолкландски острови",
  fr: "Франция",
  gf: "Френска Гвиана",
  pf: "Френска Полинезия",
  tf: "Френски южни територии",
  ht: "Хаити",
  hn: "Хондурас",
  hk: "Хонконг, САР на Китай",
  hr: "Хърватия",
  cf: "Централноафриканска република",
  td: "Чад",
  me: "Черна гора",
  cz: "Чехия",
  cl: "Чили",
  ch: "Швейцария",
  se: "Швеция",
  lk: "Шри Ланка",
  ss: "Южен Судан",
  za: "Южна Африка",
  gs: "Южна Джорджия и Южни Сандвичеви острови",
  kr: "Южна Корея",
  jm: "Ямайка",
  jp: "Япония",
};
